import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { FRONT_DEFAULT_AVATAR, resolveAvatarUrl, withAvatarFallback } from '../../utils/avatar';
import { API_BASE } from '../../config';
import useOnboardingGuard from '../../hooks/useOnboardingGuard';

function Profile() {
  const navigate = useNavigate();
  const { loading: onboardingLoading } = useOnboardingGuard();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showStorage, setShowStorage] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [friendsCount, setFriendsCount] = useState(null);

  useEffect(() => {
    let isActive = true;

    const fetchProfile = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        if (isActive) setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_BASE}/api/Profile/me`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status === 401) {
          localStorage.removeItem('token');
          navigate('/log_in');
          return;
        }

        if (!response.ok) throw new Error('Failed to fetch profile');

        const data = await response.json();
        if (!isActive) return;
        setUserData(data);

        try {
          const likesResp = await fetch(`${API_BASE}/api/Likes/mutual-likes`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (likesResp.status === 401) {
            localStorage.removeItem('token');
            navigate('/log_in');
            return;
          }

          if (likesResp.ok) {
            const likesData = await likesResp.json();
            if (Array.isArray(likesData)) setFriendsCount(likesData.length);
            else if (typeof likesData === 'object' && likesData !== null) setFriendsCount(likesData.length ?? null);
          }
        } catch (e) {
          console.error('Error fetching mutual likes:', e);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    fetchProfile();
    return () => {
      isActive = false;
    };
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/log_in');
  };

  if (loading) return <div className="flex justify-center items-center min-h-screen">Р—Р°РіСЂСѓР·РєР°...</div>;

  // If server data is available use it; otherwise fallback to localStorage
  const firstName = userData?.firstName || "Name";
  const lastName = userData?.lastName || "Surname";
  const username = userData?.nickname || userData?.username || "nickname";
  const email = userData?.email || "email@example.com";
  const city = (userData?.city && userData.city.toString().trim()) ? userData.city : "Р“РѕСЂРѕРґ";
  const profession = (userData?.jobTitle && userData.jobTitle.toString().trim()) ? userData.jobTitle : "РџСЂРѕС„РµСЃСЃРёСЏ";
  const birthDate = (userData?.birthDate && userData.birthDate.toString().trim()) ? userData.birthDate : "Р”Р°С‚Р° СЂРѕР¶РґРµРЅРёСЏ";
  const bio = (userData?.bio && userData.bio.toString().trim()) ? userData.bio : "РћРїРёСЃР°РЅРёРµ";
  const avatarUrl = userData?.avatarUrl ? resolveAvatarUrl(userData.avatarUrl) : FRONT_DEFAULT_AVATAR;

  // Build interest tags from server onboarding if present
  const interestTags = (() => {
    if (!userData?.onboarding) return [];
    try {
      if (Array.isArray(userData.onboarding)) {
        return userData.onboarding.flatMap(q => (q.selected || []).map(s => s.text || s.name || (s.Id || s.id) || ''))
          .filter(Boolean)
          .filter(text => text.toString().toLowerCase() !== 'другое' && !text.toString().toLowerCase().startsWith('option #'));
      }
    } catch (e) {
      console.warn('Unable to parse onboarding for tags', e);
    }
    return [];
  })();
  return (
    <div className="bg-[#FFFBF5] min-h-screen flex flex-col font-['TT_Norms_Pro']">
      <main className="flex-1 flex flex-col items-center py-10 px-4">
        <h1 className="text-[40px] font-bold text-[#2C2C2C] mb-12">Р›РёС‡РЅС‹Р№ РєР°Р±РёРЅРµС‚</h1>
        
        <div className="flex gap-20 max-w-[1200px] w-full items-start justify-center">
            <div className="w-auto shrink-0 pt-[68px] relative">
                {/* Main Image */}
                <div className="ml-12 relative z-10 w-[339px] h-[322px] rounded-xl overflow-hidden shadow-xl border-4 border-white bg-white">
                    <img src={avatarUrl} alt="Profile" className="w-full h-full object-cover" 
                         onError={withAvatarFallback()} />
                </div>
            </div>

            <div className="flex-1">
                <div className="flex justify-between items-center mb-6">
                  <Link to="/edit-profile" className="bg-transparent border-none text-lg font-bold cursor-pointer flex items-center gap-2 text-[#2C2C2C] no-underline hover:text-[#FF7A50] transition-colors">
                    <i className="bi bi-pencil"></i> Р РµРґР°РєС‚РёСЂРѕРІР°С‚СЊ РїСЂРѕС„РёР»СЊ
                  </Link>
                  <div className="relative">
                    <div className="flex items-center gap-4">
                      <button 
                        onClick={() => setShowLogoutModal(!showLogoutModal)}
                        className="bg-transparent border-none text-lg font-bold cursor-pointer flex items-center gap-2 text-[#C84630] hover:text-[#A03020] transition-colors"
                      >
                        <i className="bi bi-box-arrow-right"></i> Р’С‹Р№С‚Рё РёР· РїСЂРѕС„РёР»СЏ
                      </button>
                    </div>
                    {showLogoutModal && (
                      <div className="absolute right-0 top-full mt-2 w-[300px] bg-white border border-[#E0E0E0] rounded-xl shadow-lg p-4 z-20">
                        <p className="text-center С‚РµРєСЃС‚-xs font-bold text-[#2C2C2C] mb-3">Р”РµР№СЃС‚РІРёС‚РµР»СЊРЅРѕ С…РѕС‡РµС€СЊ РІС‹Р№С‚Рё РёР· РїСЂРѕС„РёР»СЏ?</p>
                        <div className="flex justify-center gap-14">
                          <Link to="/" className="px-2 py-1.5 border border-[#C84630] text-[#C84630] rounded-md text-xs font-bold no-underline hover:bg-red-50">
                            Р”Р°
                          </Link>
                          <button 
                            onClick={() => setShowLogoutModal(false)} 
                            className="px-3 py-1.5 bg-[#9B2602] text-white rounded-md text-xs font-bold border-none cursor-pointer hover:bg-[#7a1e01]"
                          >
                            РќРµС‚, РѕСЃС‚Р°С‚СЊСЃСЏ
                          </button>
                        </div>
                      </div>
                    )}
                    {showStorage && (
                      <div className="absolute right-0 top-full mt-2 w-[360px] bg-white border border-[#E0E0E0] rounded-xl shadow-lg p-4 z-30">
                      <div className="flex justify-between items-center mb-2">
                        <strong>localStorage</strong>
                        <button onClick={() => setShowStorage(false)} className="text-sm text-[#666]">Р—Р°РєСЂС‹С‚СЊ</button>
                      </div>
                      <pre className="text-xs max-h-[240px] overflow-auto">{JSON.stringify({
                        firstName: localStorage.getItem('firstName'),
                        lastName: localStorage.getItem('lastName'),
                        username: localStorage.getItem('username'),
                        email: localStorage.getItem('email'),
                        token: localStorage.getItem('token'),
                        onboarding: localStorage.getItem('onboarding_answers_v1')
                      }, null, 2)}</pre>
                      </div>
                    )}
                  </div>
                </div>
                
                <div className="flex flex-col gap-2 mb-10 max-w-[700px]">
                  <div className="flex gap-4">
                    <input type="text" value={firstName} readOnly className="flex-1 p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] outline-none" />
                    <input type="text" value={lastName} readOnly className="flex-1 p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] outline-none" />
                  </div>
                  <div className="flex gap-4">
                    <input type="text" value={username} readOnly className="flex-1 p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] outline-none" />
                    <input type="text" value={email} readOnly className="flex-1 p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] outline-none" />
                  </div>
                  <div className="flex gap-4">
                    <input type="text" value={city} readOnly className="flex-1 p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] outline-none" />
                    <input type="text" value={profession} readOnly className="flex-1 p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] outline-none" />
                  </div>
                  <div className="flex gap-4">
                    <input type="text" value={birthDate} readOnly className="flex-1 p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] outline-none" />
                    <input type="text" value={friendsCount !== null ? `${friendsCount} РґСЂСѓР·РµР№` : 'вЂ”'} readOnly className="flex-1 p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] outline-none" />
                  </div>
                  <div className="w-full">
                    <textarea readOnly className="w-full p-3 border border-[#E0E0E0] rounded-xl bg-[#FFF5F2] text-lg text-[#333] resize-none min-h-[80px] font-inherit" value={bio}></textarea>
                  </div>
                </div>

                {interestTags.length > 0 && (
                <div className="border border-[#E0E0E0] rounded-lg p-5 bg-[#FCFCFC] min-h-[100px]  w-full max-w-[700px]">
                  <div className="flex flex-wrap gap-2">
                    {interestTags.map((t, i) => (
                      <span key={i} className="bg-[#FF7A50] text-white px-3 py-2 rounded-md text-sm font-semibold">{t}</span>
                    ))}
                  </div>
                </div>
                )}
            </div>
        </div>
      </main>
      <Footer/>
    </div>
  );
}

export default Profile;

